import { Box, styled } from '@mui/material';

export const CoreBenefitsWrapper = styled(Box)({
  display: 'flex',
  gap: '12px',
  maxWidth: '100%',
  width: '100%',
  overflowX: 'auto',
  padding: '12px 0',
  '@media (min-width: 993px)': {
    gridTemplateColumns: 'repeat(1, 1fr)',
    paddingBottom: '1rem',
  },
});
